import { ChangeDetectionStrategy, Component, HostBinding, Input, computed, signal } from '@angular/core';

import { TagModel } from '@core/models/tag.model';

interface TagState {
  model: TagModel | null;
  cssClass: string;
}

@Component({
  selector: 'ux-tag',
  standalone: true,
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.less'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ux-tag' },
})
export class TagComponent {
  private readonly state = signal<TagState>({
    model: null,
    cssClass: '',
  });

  protected readonly tagName = computed(() => this.state().model?.name ?? '');

  @Input({ required: true })
  set model(value: TagModel) {
    if (!value) {
      return;
    }

    this.state.update(state => ({
      ...state,
      model: value,
      cssClass: value.cssClass || state.cssClass,
    }));
  }

  @HostBinding('class')
  protected get hostClasses(): string {
    const baseClass = 'ux-tag';
    const dynamicClass = this.state().cssClass;
    return dynamicClass ? `${baseClass} ${dynamicClass}` : baseClass;
  }

  /**
   * Updates the CSS class of the tag component
   * @param cssClass The CSS class to apply
   */
  public updateCssClass(cssClass: string): void {
    this.state.update(state => ({
      ...state,
      cssClass: cssClass || '',
    }));
  }
}
